import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRange1 = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 160 160",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M99.8003 15.4123L79.574 12.4463C68.5269 10.8248 57.2881 13.6601 48.3289 20.3267L31.9295 32.531C22.9746 39.1953 17.0316 49.1483 15.4123 60.1953L12.4463 80.4217C10.8248 91.4687 13.6601 102.708 20.3267 111.667L32.531 128.066C39.1975 137.023 49.1483 142.966 60.1954 144.588L80.4217 147.554C91.4687 149.175 102.708 146.34 111.667 139.673L128.066 127.469C137.023 120.802 142.966 110.852 144.588 99.8047L147.554 79.5783C149.175 68.5313 146.34 57.2925 139.673 48.3333L127.469 31.9338C120.803 22.9768 110.852 17.0337 99.8047 15.4123H99.8003Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgRange1);
export default ForwardRef;
